<template>
    <button class="time-interval-btn" :class="device" @click="changeInterval">
        <div>{{ chartTimeInterval }} {{ $t('button.minute') }}</div>
    </button>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

const props = defineProps({
    device: {
        type: String,
        required: true,
    },
})

const store = useStore()

const chartTimeInterval = computed(() => store.state.chartTimeInterval)

const changeInterval = () => {
    const intervals = [30, 60]
    const currentIndex = intervals.indexOf(store.state.chartTimeInterval)
    const nextInterval = intervals[(currentIndex + 1) % intervals.length]

    store.commit('setChartTimeInterval', nextInterval)
}
</script>

<style lang="scss" scoped>
.time-interval-btn {
    cursor: pointer;
    &.desktop {
        border: 1px solid #ccc;
        background-color: #f0f0f0;
        padding: 5px 6px;
        border-radius: 4px;
        &:hover {
            background-color: #e0e0e0;
        }
    }
    &.mobile {
        border: 1px solid #f0f0f0;
        background-color: #ffffff;
        padding: 0.2rem 0.5rem;
        margin: 0.2rem 0;
        text-align: center;
        border-radius: 4px;
    }
}
</style>
